export default __webpack_public_path__ + "static/media/courseCoverImage.e6a6f0eb.png";